// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Landing from "../../templates/Landing.re.mjs";
import * as JsxRuntime from "react/jsx-runtime";

import { css, cx } from '@linaria/core'
;

var heroImg = {
  src: "https://images.instapainting.com/60ed190caca84f844d8b4570.jpg",
  alt: "A horse and her owner painted in the style of The Great Wave Off Kanagawa, but with oil paint"
};

var pageTitle = "Custom Horse Portrait Painting";

var title = "Order a personalized";

var title2 = " oil painting of your horse";

var metaDescription = "Turn your horse photo into a personalized, handmade portrait. View thousands of examples from real customers. Ready to be shipped in about 7-10 days.";

var description = "Turn your favorite photo into a 100% handmade physical painting from a master artist in oil, watercolor, charcoal, or other mediums. Select a product, upload a photo, and we'll find the best horse paintings artist to make it and ship it to your door. All you have to do to get started is upload your horse’s photo!";

var secondaryContent = {
  title1: "Custom Horse",
  title2: "Portrait Painting",
  body: "You can browse horse painting samples from real customers and artists. Choose from a variety of horse portrait painting styles to get the style and design you prefer. A handmade portrait of a horse could be a great housewarming gift, birthday present, pet memorial, or celebratory gift for any horse lover. Our horse paintings are never created digitally; they are 100% handmade by talented artists from around the globe. At Instapainting, we make it easy for you to work directly with the artist to customize and review your one-of-a-kind portrait of a horse so you have peace of mind knowing you’ll get exactly what you paid for."
};

var mainCta = {
  text: "Upload a Photo",
  link: "/assets"
};

var altCta = {
  text: "Browse Horses Gallery",
  link: "/gallery/horse"
};

var products = [
  {
    title: "Oil Painting",
    src: "https://images.instapainting.com/6030ddac87456f06358b4569.jpg?fp-z=1.25&fp-x=0.4&fp-y=0.5",
    imageAlt: "Two horseback riders in a field",
    sku: "custphotoreal",
    price: 89
  },
  {
    title: "Watercolor",
    src: "https://images.instapainting.com/612cabd14f8504bb0c8b4579_w0.jpg?fp-z=1.2&fp-y=0.55",
    imageAlt: "Watercolor portrait painting of an owner and her horse",
    sku: "custwatercolor",
    price: 89
  },
  {
    title: "Charcoal",
    src: "https://images.instapainting.com/5f73506987456fbd458b4569_w0.jpg?fp-z=1.25&fp-y=0.4&fp-x=0.5",
    imageAlt: "Portrait of a horse in a field looking back",
    sku: "custcharcoal",
    price: 89
  },
  {
    title: "Pencil Drawing",
    src: "https://images.instapainting.com/5e56855287456f92178b4590_w0.jpg?fp-z=1.2&fp-y=0.5",
    imageAlt: "Pencil drawing of an older lady and her horse",
    sku: "custpencil",
    price: 89
  },
  {
    title: "Colored-Pencil",
    src: "https://images.instapainting.com/5ea5255487456fb41a8b4599.jpg?fp-z=1.0",
    imageAlt: "Colored pencil drawing of a lady riding a horse in the woods",
    sku: "custpencil",
    price: 89
  }
];

var reviews = [
  {
    name: "Sandra Wiley",
    location: "Hyde Park, US",
    review: "Just beautiful!",
    link: "/products/gallery/custpencil/60a9c6236b3f0214048b456a/?order=1",
    image: "https://images.instapainting.com/60b2ea8fdae3daf8308b456e.jpg?fit=crop&crop=focalpoint&fp-y=.55&fp-z=2",
    imageAlt: "A horse resting his head on a wooden fence, drawn in pencil",
    date: new Date("5/31/2021")
  },
  {
    name: "Regan Lehman Pillar",
    location: "Lawrence, US",
    review: "Joy did an absolutely spectacular job on the painting of my friend and her horse. She was incredibly easy to work with and the results blew me away. I was impressed when I received her final update before shipping, but it was nothing compared to what it was like to see it in person. Very well done.",
    link: "/products/gallery/custphotoreal/5a25c7f887456fcc128b465b/?order=1",
    image: "https://images.instapainting.com/5a51d40c87456fc0318b4578.jpg",
    imageAlt: "A woman riding a horse through splashing water painted in oil in the style of Udnie, Young American Girl by Francis Picabia",
    date: new Date("02/05/2018")
  },
  {
    name: "Douglas L. Stafford",
    location: "Concord, US",
    review: "The painting is beautiful, an excellent reproduction of a Rembrandt Peale painting of George Washington on horseback. Outstanding value for the price we paid. I can enthusiastically recommend Instapainting and Dearchic Arts to anyone who desires a high quality painting.",
    link: "/products/gallery/custphotoreal/599a2e1487456fd52b8b45b6/?order=1",
    image: "https://images.instapainting.com/59abcd8a87456f00478b456c.jpg",
    imageAlt: "An oil painting replica of a Rembrandt Peale painting of George Washington on horseback",
    date: new Date("09/23/2017")
  }
];

var contentBlocks = [
  {
    title1: "Hand-Painted Portrait of",
    title2: "Your Favorite Horse",
    body: "Cherish your horse forever with a beautiful horse portrait that perfectly captures his or her personality. Or, give a loved one the gift of a commissioned horse portrait that they’ll adore for years to come. There are many different reasons why you might want a portrait of a horse, whether you plan to donate it to a worthy cause, decorate your own home, give a creative gift, or memorialize a family pet. Whatever your reasoning, we can help you get the horse portrait of your dreams.\n\nAt Instapainting, we’ll connect you with a professional artist that has years of experience creating beautiful handmade portraits. He or she will create a gorgeous horse portrait that meets your specifications and stylistic preferences. You can even choose from a variety of mediums like watercolor paintings, oil paintings, or a charcoal or pencil horse portrait, depending on what you want. Whatever the style or occasion, we can help you get the perfect horse portrait."
  },
  {
    title1: "Capture Your Cute Pony",
    title2: "on Canvas",
    body: "Every pony has its own distinct personality. So, why not capture the essence of your sweet, cheeky, or smart pony with a gorgeous handcrafted pony painting? Not only is it a unique way to honor your special pony, but it’s also a creative and fun way to revisit a special moment over and over again, memorialize your pony that recently passed away, or decorate your home with a personalized painting that brings you joy.\n\nAlthough it’s difficult to encapsulate the precious relationship you have with your pony with one single painting, our talented artists have plenty of experience doing just that and we can help you do it! All of our professional artists use the highest quality materials and have real-life experience creating beautiful customized portraits from photos. They will work closely with you to make sure the final product is everything you wanted and accurately captures your pony’s distinct beauty and personality."
  },
  {
    title1: "Turn a Funny Photo of Your Exotic Equine",
    title2: "Into a Cherished Memory",
    body: "Horses are some of the most beautiful creatures. But as exquisite as they are, even a horse can be goofy and silly sometimes, prompting some of the best funny photos. If you have a favorite funny photo of your horse, you might consider turning it into a fantastic and one-of-a-kind piece of art. When you upload it to Instapainting, our artists will help you transform it into a memorable horse painting that’s sure to bring you joy and happiness for years to come.\n\nOur professional artists will partner with you to create a funny horse portrait that lifts you up when you feel down, inspires you, or conveys a powerful message. Whether the funny horse painting is for you, a family member, or a special friend, turning your funny horse photo into a custom painting is a creative and fun way to embody and illustrate a special message. Not to mention, it’s a gift that will be admired and enjoyed for a lifetime."
  },
  {
    title1: "",
    title2: "Start by Uploading Your Photo Today",
    body: "If you’re ready to commission your custom horse portrait, we have the perfect solution for you. We can make the process easier, faster, and more enjoyable by helping you select an artist that will hand-paint your horse portrait for you. Simply start by selecting the type of artwork you want (watercolor, charcoal sketch, oil painting, etc.), upload your horse’s photo, include any additional instructions for the artist, and submit your order.\n\nFrom there, we’ll help you select the artist that best meets your stylistic preferences, needs, and budget to ensure that you’re happy with the process from start to finish. Once the artist begins working on your custom horse portrait, you’ll have the opportunity to submit unlimited revisions to make sure you’re happy with the final version. To make things even easier, we’ll safely package and ship your horse painting to you, with the whole process generally taking less than three weeks!\n\nReady to get started? Take the first step by uploading your horse’s photo today."
  }
];

function HorsePaintingsPage(props) {
  return JsxRuntime.jsx(Landing.LandingPage.make, {
              pageTitle: pageTitle,
              heroImg: heroImg,
              title: title,
              title2: title2,
              description: description,
              metaDescription: metaDescription,
              secondaryContent: secondaryContent,
              mainCta: mainCta,
              altCta: altCta,
              products: products,
              reviews: reviews,
              contentBlocks: contentBlocks
            });
}

var make = HorsePaintingsPage;

var $$default = HorsePaintingsPage;

export {
  heroImg ,
  pageTitle ,
  title ,
  title2 ,
  metaDescription ,
  description ,
  secondaryContent ,
  mainCta ,
  altCta ,
  products ,
  reviews ,
  contentBlocks ,
  make ,
  $$default as default,
}
/*  Not a pure module */
